import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
  PLATFORM_ID,
  Inject,
  AfterViewInit
} from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-webinar',
  templateUrl: './webinar.component.html',
  styleUrls: ['./webinar.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule]
})
export class WebinarComponent implements OnInit, AfterViewInit, OnDestroy {
  isFormSubmitted: any;
  minutes: number = 0;
  seconds: number = 0;
  countdownMessage: string = '';
  private countdownInterval: any;

  constructor(
    private router: Router,
    private http: HttpClient,
    private snackBar: MatSnackBar,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  baseUrl = environment.baseUrl;

  ngOnInit(): void {
    // Initialize with default values
    this.minutes = 15;
    this.seconds = 0;
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      // Set the target time for 15 minutes from now
      const targetDate = new Date().getTime() + 15 * 60 * 1000;

      // Update the countdown every second
      this.countdownInterval = setInterval(() => {
        // Get the current time
        const now = new Date().getTime();

        // Calculate the time remaining
        const remainingTime = targetDate - now;

        // Time calculations for minutes and seconds
        this.minutes = Math.floor(
          (remainingTime % (1000 * 60 * 60)) / (1000 * 60)
        );
        this.seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);

        // If the countdown is finished, display a message
        if (remainingTime < 0) {
          clearInterval(this.countdownInterval);
          this.minutes = 0;
          this.seconds = 0;
          this.countdownMessage = 'The Webinar Has Started!';
        }
      }, 1000);
    }
  }

  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId) && this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  scrollToForm(item: string) {
    if (isPlatformBrowser(this.platformId)) {
      const form = document.getElementById(item);
      if (form) {
        form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

  compactForm = new FormGroup({
    full_name: new FormControl('', [Validators.required]),
    phone: new FormControl('', [Validators.required, Validators.email]),
    email: new FormControl('', [
      Validators.required,
      Validators.pattern('^[0-9]*$'),
    ]),
    loan_type_id: new FormControl(19, [Validators.required]),
  });

  onSubmit() {
    if (!isPlatformBrowser(this.platformId)) return;

    const formData = { ...this.compactForm.value };

    console.log('Compact Form Submission Object:', formData);

    this.http.post(`${this.baseUrl}/add_basic_enquiry`, formData).subscribe({
      next: (res: any) => {
        console.log('Response from API:', res);
        if (res.success) {
          console.log('Submission successful!');
          this.isFormSubmitted = true;
          this.snackBar.open(
            'Enquiry Added successful! Thank you for your enquiry!',
            'Close',
            { duration: 5000 }
          );

          this.compactForm.reset();

          setTimeout(() => {
            this.isFormSubmitted = false;
          }, 5000);
        } else {
          console.log('Submission failed:', res);
          this.snackBar.open('Submission failed. Please try again.', 'Close', {
            duration: 5000,
          });
        }
      },
      error: (err: any) => {
        console.log('Error during submission:', err);
        this.snackBar.open('An error occurred. Please try again.', 'Close', {
          duration: 5000,
        });
      },
    });
  }
}
